/* global google */
const params = window.$ezMapParams;

const sidebar = document.querySelector('.ezpark-map-sidebar');

function initMap() {
  const map = new google.maps.Map(document.querySelector('.ezpark-map'), {
    zoom: 4,
  });
  
  /* Setup map area */
  const bounds = new google.maps.LatLngBounds();
  bounds.extend(
    new google.maps.LatLng(
      parseFloat(params.bounds.ne_coord.lat),
      parseFloat(params.bounds.ne_coord.lng),
    ),
  );
  bounds.extend(
    new google.maps.LatLng(
      parseFloat(params.bounds.sw_coord.lat),
      parseFloat(params.bounds.sw_coord.lng),
    ),
  );
  map.fitBounds(bounds);
  
  /* Setup icons */
  const smallIcon = {
    url: params.smallIcon,
    scaledSize: new google.maps.Size(27, 43),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(14, 43),
  };
  const searchIcon = {
    url: params.searchIcon,
    scaledSize: new google.maps.Size(25, 25),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(13, 13),
  };
  const selectedSearchIcon = {
    url: params.selectedSearchIcon,
    scaledSize: new google.maps.Size(31, 31),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(16, 16),
  };
  const markers = [];

  /* Shows a lot in the sidebar */
  const showLot = function showLotInSidebar(marker) {
    // Get the currently visible lot and make it not visible
    const visibleLot = document.querySelector('.ezpark-map-lot--visible');
    if (visibleLot !== null) { // classList errors if null
      visibleLot.classList.remove('ezpark-map-lot--visible');
    }
  
    // Show the requested lot
    const selectedLot = document.querySelector(`.ezpark-map-lot[data-lot="${marker.id}"]`);
    if (selectedLot !== null) {
      selectedLot.classList.add('ezpark-map-lot--visible');
    }
  
    // Set the other markers' icons to smallIcon
    for (let i = 0; i < markers.length; i += 1) {
      if (markers[i].id !== marker.id) {
        if (markers[i].type === 'lot') {
          markers[i].setIcon(smallIcon);
        } else if (markers[i].type === 'search') {
          markers[i].setIcon(searchIcon);
        }
      }
    }
  
    const position = marker.getPosition();
    marker.setIcon(null);
  
    // Show the sidebar if currently hidden
    sidebar.classList.remove('ezpark-map-sidebar--hidden');
  
    // Pan the map to the position of the lot
    map.panTo(position);
  };
  
  /* Place markers */
  params.markers.forEach((location) => {
    const lat = parseFloat(location.lat);
    const lng = parseFloat(location.lng);
    const marker = new google.maps.Marker({
      position: { lat, lng },
      map,
      icon: smallIcon,
      optimized: false,
    });
  
    marker.set('id', location.id);
    marker.set('type', 'lot');
  
    // Pan to marker on click
    google.maps.event.addListener(marker, 'click', () => {
      showLot(marker);
    });
  
    markers.push(marker);
  });

  /* Show the default lot */
  if (window.innerWidth >= 640 && params.defaultLot !== null) {
    // Find the correct marker
    for (let i = 0; i < markers.length; i += 1) {
      // eslint-disable-next-line eqeqeq
      if (markers[i].id == params.defaultLot) {
        showLot(markers[i]);
      }
    }
  }
  
  /* Handle search result clicks */
  const searchResult = document.querySelectorAll('.ezpark-map-result');
  
  for (let i = 0; i < searchResult.length; i += 1) {
    const result = searchResult[i];
    result.addEventListener('click', (event) => {
      event.preventDefault();
      const lotID = result.dataset.lot;
      for (let j = 0; j < markers.length; j += 1) {
        // double equals since lotID may be a string and marker.id is an int
        // eslint-disable-next-line eqeqeq
        if (markers[j].id == lotID) {
          showLot(markers[j]);
        }
      }
    });
  }
  
  /* Close sidebar */
  const sidebarClose = document.querySelector('.ezpark-map-sidebar-close');
  
  sidebarClose.addEventListener('click', (event) => {
    event.preventDefault();
    sidebar.classList.add('ezpark-map-sidebar--hidden');
  
    // Set the all lot markers' icons to smallIcon
    for (let i = 0; i < markers.length; i += 1) {
      const marker = markers[i];
      if (marker.type === 'lot') {
        marker.setIcon(smallIcon);
      }
    }
  });

  let centerLocation = map.getCenter();

  /**
   * The CenterControl adds a control to the map that recenters the map on
   * Chicago.
   * This constructor takes the control DIV as an argument.
   * Adapted from https://developers.google.com/maps/documentation/javascript/examples/control-custom
   */
  function CenterControl(controlDiv) {
    // Set CSS for the control border.
    const controlUI = document.createElement('div');
    controlUI.style.backgroundColor = '#fff';
    controlUI.style.border = '2px solid #fff';
    controlUI.style.borderRadius = '3px';
    controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
    controlUI.style.cursor = 'pointer';
    controlUI.style.margin = '10px';
    controlUI.style.textAlign = 'center';
    controlUI.classList.add('gmnoprint');
    controlUI.classList.add('gm-style-mtc');
    controlUI.title = 'Click to recenter the map';
    controlDiv.appendChild(controlUI);

    // Set CSS for the control interior.
    const controlText = document.createElement('div');
    controlText.style.color = 'rgb(25,25,25)';
    controlText.style.fontFamily = 'Roboto,Arial,sans-serif';
    controlText.style.fontSize = '16px';
    controlText.style.lineHeight = '38px';
    controlText.style.paddingLeft = '17px';
    controlText.style.paddingRight = '17px';
    controlText.role = 'button';
    controlText.innerHTML = 'Recenter Map';
    controlUI.appendChild(controlText);

    // Setup the click event listeners: simply set the map to Chicago.
    controlUI.addEventListener('click', () => {
      map.panTo(centerLocation);
    });
  }

  /* Center + zoom on search location */
  if (params.place_coords) {
    centerLocation = params.place_coords;
    
    map.panTo(centerLocation);
    map.setZoom(15);
    
    const searchMarker = new google.maps.Marker({
      position: centerLocation,
      map,
      icon: selectedSearchIcon,
      optimized: false,
    });

    searchMarker.set('type', 'search');

    google.maps.event.addListener(searchMarker, 'click', () => {
      map.panTo(searchMarker.getPosition());
      searchMarker.setIcon(selectedSearchIcon);
    });

    markers.push(searchMarker);

    // Create the DIV to hold the control and call the CenterControl()
    // constructor passing in this DIV.
    const centerControlDiv = document.createElement('div');
    // eslint-disable-next-line no-unused-vars
    const centerControl = new CenterControl(centerControlDiv);

    centerControlDiv.index = 1;
    map.controls[google.maps.ControlPosition.TOP_CENTER].push(centerControlDiv);
  }
}

// eslint-disable-next-line no-use-before-define
const $inits = $inits || [];
$inits.push(
  () => {
    initMap();
  },
);
